import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import "../styles/BookingConfirmation.css";
import { CiCircleCheck } from "react-icons/ci";

const BookingConfirmation = () => {
    const navigate = useNavigate(); //hook for navigating between pages
    const location = useLocation(); // gets data passed from previous page

    //extract reservation details from passed state
    const { reservationId, totalPrice } = location.state || {};

    //get current date formatted
    const currentDate = new Date().toLocaleDateString("en-US", {
        day: "2-digit", month: "short", year: "2-digit"
    });

    //navigate to the user's booking history
    const handleGoToBookings = () => {
        navigate("/bookings");
    };

    // If no reservation ID is found, show an error message
    if (!reservationId) {
        return <p className="error-message" role="alert">No booking found</p>;
    }

      return (
            <main className="booking-ticket-container">
                <article className="ticket" aria-labelledby="ticket-title">
                    <header className="ticket-header">
                        <h2 id="ticket-title">Booking Confirmed!</h2>
                    </header>
                    <section className="ticket-body">
                    <p className="warning-text">Please bring your reservation number to your visit.</p>
                    <ul className="booking-details" role="list">
                        <li>
                            <strong className="label">Reservation #</strong>
                            <code className="value">{reservationId}</code>
                        </li>
                        <li>
                            <strong className="label">Total Price</strong>
                            <p className="value" style={{margin:0}}>${totalPrice}</p>
                        </li>
                        <li>
                            <strong className="label">Date</strong>
                            <time className="value" dateTime={new Date().toISOString().split('T')[0]}> {currentDate}</time>
                        </li>
                    </ul>
                    </section>
                    <footer className="ticket-footer">
                    <figure>
                        <QRCodeCanvas value={reservationId.toString()} className="qr-code" aria-label="Reservation QR code" />
                        <figcaption className="visually-hidden">Show this QR code at the entrance</figcaption>
                    </figure>
                    </footer>
                </article>
           <button className="goToBookings-button" onClick={handleGoToBookings} aria-label="Go to bookings">
             <CiCircleCheck aria-hidden="true" />
           </button>
            </main>
    );
};

export default BookingConfirmation;
